import axios from 'axios';
import get from 'lodash.get';
import SfConstants from '../../constants/shared/SfConstant';
import KeycloakClient from '../../api/clients/shared/KeycloakClient';
import ReadingEnrollmentClient from '../../api/clients/reading/EnrollmentClient';

const { BASE_URL, SCRIPT_SRC, BOT_ADDRESS, SCRT_2_URL, SF_ORG_ID, BOT_LABEL, EVENT_TYPES } =
    SfConstants;

export const detectChatOpen = setSfChatIsOpen => {
    const sfChatFrame = document.getElementById('embedded-messaging');

    if (sfChatFrame) {
        const observer = new MutationObserver(mutationList => {
            mutationList.forEach(({ type, removedNodes }) => {
                if (type === 'childList') {
                    const chatIsOpened = !removedNodes?.length;
                    setSfChatIsOpen(chatIsOpened);
                }
            });
        });

        observer.observe(sfChatFrame, { childList: true, subtree: true });
    }
};

export const getIPFromAmazon = async () => {
    const result = await axios.get('https://checkip.amazonaws.com/');
    const { data } = result;

    return data?.replace(/\n/g, '');
};

// For character limit of 100 as advised by Eng-salesforce-team
const extractFieldAndTruncate = (array, param) =>
    array
        .map(item => item[param])
        .join(', ')
        .slice(0, 100);

export const getPrechatFields = async () => {
    const kcUserEmail = KeycloakClient.getUserEmail();
    const ipAddress = await getIPFromAmazon();
    const referralUrl = window.location.href || '';
    const userFirstName = KeycloakClient.getUserFirstName();
    const userLastName = KeycloakClient.getUserLastName();
    const userBK = KeycloakClient.getSessionId();
    const product = 'mclass-reports';
    const urlParams = new URLSearchParams(window.location.search);
    const districtId = urlParams.get('district') || '';
    const schoolId = urlParams.get('school') || '';

    const params = {
        district: districtId,
        school: schoolId,
    };

    const enrollmentData = await ReadingEnrollmentClient.getEnrollmentInfo(params);

    const districts = get(enrollmentData, 'enrollmentData.districts', []);
    const schools = get(enrollmentData, 'enrollmentData.schools', []);

    const districtNames = extractFieldAndTruncate(districts, 'name');
    const districtIds = extractFieldAndTruncate(districts, 'uid');

    const schoolNames = extractFieldAndTruncate(schools, 'name');
    const schoolIds = extractFieldAndTruncate(schools, 'uid');

    return {
        email: kcUserEmail,
        ip_address: ipAddress,
        referral_url: referralUrl,
        firstName: userFirstName,
        lastName: userLastName,
        amplify_id: userBK,
        mClass_product: product,
        district_id: districtIds,
        school_id: schoolIds,
        school_name: schoolNames,
        district_name: districtNames,
    };
};

export const initEmbeddedMessaging = async (setSfChatIsOpen, onIntializeChat) => {
    try {
        const identityToken = KeycloakClient.getToken();
        const preChatFields = await getPrechatFields();

        window.embeddedservice_bootstrap.settings.language = 'en_US';

        window.addEventListener(EVENT_TYPES.ON_READY, () => {
            window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields(preChatFields);

            window.embeddedservice_bootstrap.userVerificationAPI.setIdentityToken({
                identityTokenType: 'JWT',
                identityToken,
            });
            if (typeof onIntializeChat === 'function') {
                onIntializeChat();
            }
        });

        window.addEventListener(EVENT_TYPES.ON_TOKEN_EXPIRED, () => {
            window.embeddedservice_bootstrap.userVerificationAPI.setIdentityToken({
                identityTokenType: 'JWT',
                identityToken,
            });
        });

        window.embeddedservice_bootstrap.init(SF_ORG_ID, BOT_LABEL, BOT_ADDRESS, {
            scrt2URL: SCRT_2_URL,
        });

        detectChatOpen(setSfChatIsOpen);
    } catch (err) {
        // eslint-disable-next-line
    console.error('SF Chat: Error loading script. ', err);
    }
};

const createCspMetaTag = () => {
    const meta = document.createElement('meta');
    meta.setAttribute('http-equiv', 'Content-Security-Policy');
    meta.setAttribute('content', `script-src 'self' ${BASE_URL} `);
    document.head.appendChild(meta);
    return meta;
};

const createSfScriptTag = setSfChatIsOpen => {
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);

    script.onload = async () => {
        try {
            const preChatFields = await getPrechatFields();
            await initEmbeddedMessaging(setSfChatIsOpen, () => {
                // eslint-disable-next-line
                console.log('chat is initialized');
                // eslint-disable-next-line
                console.log('preChatFields: ', preChatFields);
            });
        } catch (err) {
            // eslint-disable-next-line
            console.error(err);
        }
    };
};

export { createCspMetaTag, createSfScriptTag };
